import { defineStore } from 'pinia'

export const useLoadingStore = defineStore('loading', () => {
  const loading = ref(false)
  const loadingText = ref('Just a moment, your content is on the way.')
  const show = ref(false)

  const startLoading = (text = 'Just a moment, your content is on the way.') => {
    loadingText.value = text
    loading.value = true
    show.value = true
  }

  const stopLoading = () => {
    loading.value = false
    // 添加一个延迟，避免闪烁
    setTimeout(() => {
      if (!loading.value) {
        show.value = false
      }
    }, 200)
  }

  return {
    loading,
    loadingText,
    show,
    startLoading,
    stopLoading
  }
})